import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollPanelModule } from 'primeng/scrollpanel';

@Component({
  selector: 'app-debug',
  standalone: true,
  imports: [CommonModule, ScrollPanelModule],
  templateUrl: './debug.component.html',
  styleUrl: './debug.component.scss',
})
export class DebugComponent {
  @Input() debugOutput: any = undefined;
}
